import { render } from "./Particle.vue?vue&type=template&id=8f0b9aca"
import script from "./Particle.vue?vue&type=script&lang=js"
export * from "./Particle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__